export const IntentTypeEnum = {
  saveContent: 'save_content',
};
